var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "view-container" },
    [
      _c("div", { staticClass: "header" }, [
        _c("div", { staticClass: "tab" }, [
          _c(
            "span",
            {
              staticClass: "tabItem",
              class: { active: _vm.active === 0 },
              on: {
                click: function ($event) {
                  return _vm.handleTabClick(0)
                },
              },
            },
            [_vm._v(" 海运 ")]
          ),
          _c(
            "span",
            {
              staticClass: "tabItem",
              class: { active: _vm.active === 1 },
              on: {
                click: function ($event) {
                  return _vm.handleTabClick(1)
                },
              },
            },
            [_vm._v(" 空运 ")]
          ),
        ]),
        _c(
          "div",
          { staticClass: "optheader" },
          [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "permission",
                    rawName: "v-permission",
                    value: "export",
                    expression: "'export'",
                  },
                ],
                staticClass: "btn flex_c_c",
                staticStyle: { "margin-right": "12px" },
                on: { click: _vm.handleExport },
              },
              [_c("i", { staticClass: "el-icon-download" }), _vm._v(" 导出 ")]
            ),
            _c(
              "BaseFilter",
              {
                attrs: { "is-active": _vm.isActive, width: 466 },
                on: {
                  sendFilter: _vm.handleSearchOk,
                  reset: _vm.handleSearchReset,
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "filter" },
                  [
                    _c(
                      "el-form",
                      {
                        ref: "searchForm",
                        attrs: { model: _vm.searchData, "label-width": "70px" },
                      },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "客户" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "310px" },
                                attrs: {
                                  filterable: "",
                                  multiple: "",
                                  clearable: "",
                                  placeholder: "请选择",
                                },
                                model: {
                                  value: _vm.searchData.companyId,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.searchData, "companyId", $$v)
                                  },
                                  expression: "searchData.companyId",
                                },
                              },
                              _vm._l(_vm.companyOptions, function (item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label: item.label,
                                    value: item.value,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "搜索" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "320px" },
                              attrs: { placeholder: "提单号" },
                              model: {
                                value: _vm.searchData.search,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchData, "search", $$v)
                                },
                                expression: "searchData.search",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            ),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "data" },
        [
          _c(
            "el-tabs",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "el-tabs",
              attrs: { type: "border-card" },
              on: { "tab-click": _vm.handleTabClick },
              model: {
                value: _vm.title,
                callback: function ($$v) {
                  _vm.title = $$v
                },
                expression: "title",
              },
            },
            [
              _c("el-tab-pane", {
                attrs: { label: "所有(" + _vm.form.all + ")", name: "All" },
              }),
              _c("el-tab-pane", {
                attrs: {
                  label: "待审预报(" + _vm.form.one + ")",
                  name: "PendingReview",
                },
              }),
              _c("el-tab-pane", {
                attrs: {
                  label: "待发预报(" + _vm.form.two + "）",
                  name: "ToBeDispatched",
                },
              }),
              _c("el-tab-pane", {
                attrs: {
                  label: "已发美国(" + _vm.form.three + "）",
                  name: "SentUS",
                },
              }),
              _c("el-tab-pane", {
                attrs: {
                  label: "作废(" + _vm.form.four + "）",
                  name: "Cancel",
                },
              }),
              _c(
                "div",
                { staticClass: "table" },
                [
                  _c("BaseTable", {
                    attrs: {
                      height: _vm.height,
                      "table-data": {
                        ..._vm.list,
                        fileds: _vm.fileds,
                      },
                      "page-number": _vm.pager.PageIndex,
                      "page-size": _vm.pager.PageSize,
                    },
                    on: {
                      handlePageChange: _vm.handlePageChange,
                      dblclick: _vm.handleRowDoubleClick,
                      "selection-change": _vm.handleSelectionChange,
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "opt",
                        fn: function (row) {
                          return [
                            _c(
                              "el-popover",
                              {
                                ref: `popover${row.scope.id}`,
                                attrs: {
                                  placement: "bottom-start",
                                  "popper-class": "pop-table-opt",
                                  width: "114",
                                  trigger: "click",
                                },
                              },
                              [
                                _c("div", { staticClass: "table-opt" }, [
                                  row.scope.status == 5 ||
                                  row.scope.status == 4 ||
                                  row.scope.status == 3 ||
                                  row.scope.status == 2
                                    ? _c(
                                        "div",
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              staticClass: "opt-item",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleCommand(
                                                    "view",
                                                    row.scope
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("查看审单")]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  row.scope.status == 0 ||
                                  row.scope.status == 1 ||
                                  row.scope.status == 6
                                    ? _c(
                                        "div",
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              staticClass: "opt-item",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleCommand(
                                                    "documentReview",
                                                    row.scope
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("审单")]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  row.scope.status == 2 ||
                                  row.scope.status == 3 ||
                                  row.scope.status == 4 ||
                                  row.scope.status == 5 ||
                                  row.scope.status == 6 ||
                                  row.scope.status == 7
                                    ? _c(
                                        "div",
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              staticClass: "opt-item",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleCommand(
                                                    "returnForReview",
                                                    row.scope
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("退回重审")]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  row.scope.status == 0 ||
                                  row.scope.status == 1 ||
                                  row.scope.status == 6
                                    ? _c(
                                        "div",
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              staticClass: "opt-item",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleCommand(
                                                    "cancel",
                                                    row.scope
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("作废")]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  row.scope.status == 2 || row.scope.status == 3
                                    ? _c(
                                        "div",
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              staticClass: "opt-item",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleCommand(
                                                    "sentUSEmail",
                                                    row.scope
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("发送美国")]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  row.scope.status == 4
                                    ? _c(
                                        "div",
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              staticClass: "opt-item",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleCommand(
                                                    "sentUSEmail",
                                                    row.scope
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("重发")]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ]),
                                _c("img", {
                                  attrs: {
                                    slot: "reference",
                                    src: require("@/assets/images/table/opt.png"),
                                  },
                                  slot: "reference",
                                }),
                              ]
                            ),
                          ]
                        },
                      },
                      {
                        key: "fileNumber",
                        fn: function (row) {
                          return [
                            _c(
                              "i",
                              {
                                staticClass: "el-icon-folder-opened",
                                staticStyle: { color: "black" },
                                on: {
                                  click: function ($event) {
                                    return _vm.viewFile(row.scope)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(row.scope.fileNumber))]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            visible: _vm.dialogFormVisible,
            title: "发送美国",
            "destroy-on-close": false,
            "before-close": _vm.sentUSDialogClose,
            width: "36%",
            top: "5vh",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "form2",
              attrs: {
                model: _vm.form2,
                rules: _vm.rules2,
                "label-width": "100px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "清关行：", prop: "supplierClearenceId" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        filterable: "",
                        clearable: "",
                        placeholder: "请输入选择清关行",
                      },
                      on: { change: _vm.supplierCodeChange },
                      model: {
                        value: _vm.form2.supplierClearenceId,
                        callback: function ($$v) {
                          _vm.$set(_vm.form2, "supplierClearenceId", $$v)
                        },
                        expression: "form2.supplierClearenceId",
                      },
                    },
                    _vm._l(_vm.supplierOptions, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: {
                          label: item.code + "-" + item.wbName,
                          value: item.id,
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Email To", prop: "receiver" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      autosize: "",
                      autocomplete: "off",
                      autosize: { minRows: 1, maxRows: 4 },
                    },
                    model: {
                      value: _vm.form2.receiver,
                      callback: function ($$v) {
                        _vm.$set(_vm.form2, "receiver", $$v)
                      },
                      expression: "form2.receiver",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "CC：" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      autosize: "",
                      autocomplete: "off",
                      placeholder: "请输入电子邮件地址",
                      autosize: { minRows: 1, maxRows: 4 },
                    },
                    on: { blur: _vm.validateEmailList },
                    model: {
                      value: _vm.form2.cc,
                      callback: function ($$v) {
                        _vm.$set(_vm.form2, "cc", $$v)
                      },
                      expression: "form2.cc",
                    },
                  }),
                ],
                1
              ),
              _vm.validationError
                ? _c("span", { staticStyle: { color: "red" } }, [
                    _vm._v(_vm._s(_vm.validationError)),
                  ])
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: "主题", prop: "title" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      autosize: "",
                      "show-word-limit": "",
                      autosize: { minRows: 1, maxRows: 4 },
                    },
                    model: {
                      value: _vm.form2.title,
                      callback: function ($$v) {
                        _vm.$set(_vm.form2, "title", $$v)
                      },
                      expression: "form2.title",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "正文", prop: "content" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      autosize: "",
                      "show-word-limit": "",
                      autosize: { minRows: 3, maxRows: 5 },
                    },
                    model: {
                      value: _vm.form2.content,
                      callback: function ($$v) {
                        _vm.$set(_vm.form2, "content", $$v)
                      },
                      expression: "form2.content",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "请勾选需要发送的文件",
                    "label-width": "240",
                  },
                },
                [
                  _c("Table", {
                    ref: "customTable",
                    attrs: {
                      tableData: _vm.tableData1,
                      height: 190,
                      pageFooter: false,
                    },
                    on: { selectionchange: _vm.selectionchange2 },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (row) {
                          return [
                            _c(
                              "el-button",
                              { attrs: { type: "text", size: "mini" } },
                              [
                                _c(
                                  "span",
                                  {
                                    staticStyle: { "font-size": "12px" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.download(row.scope)
                                      },
                                    },
                                  },
                                  [_vm._v("下载")]
                                ),
                              ]
                            ),
                            [".pdf", ".PDF", ".JPG", ".jpg"].includes(
                              row.scope.suffix
                            )
                              ? _c(
                                  "el-button",
                                  {
                                    staticStyle: { "font-size": "12px" },
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.preview(row.scope)
                                      },
                                    },
                                  },
                                  [_vm._v(" 预览 ")]
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              staticStyle: { display: "contents", "margin-top": "-30px" },
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.sentUSDialogClose } }, [
                _vm._v("取 消"),
              ]),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  attrs: { type: "primary" },
                  on: { click: _vm.submitForm },
                },
                [_vm._v("发 送")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("ClearenceFileDialog", {
        attrs: { rowData: _vm.rowData, dialogVisible: _vm.dialogVisible1 },
        on: {
          cancel: function ($event) {
            _vm.dialogVisible1 = false
          },
        },
      }),
      _c("DetailDrawer", {
        attrs: {
          drawer: _vm.drawer1,
          billType: _vm.active,
          rowData: _vm.rowData,
        },
        on: {
          close: function ($event) {
            _vm.drawer1 = false
          },
        },
      }),
      _c("EditForecaseDrawer", {
        attrs: {
          drawer: _vm.drawer2,
          mblType: _vm.active,
          rowData: _vm.rowData,
          controlOverInvoicesId: _vm.rowData.id,
          isCheck: _vm.isCheck,
        },
        on: { ok: _vm.ok, close: _vm.close },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }